jQuery(document).ready(function() {
  
  // pill tabs
  jQuery("._ptList li, ._htHead li").on("click", function(){
    jQuery(this).addClass("active").siblings().removeClass("active");
    const activePill = jQuery(this).attr("data-target");
    jQuery("#"+activePill).addClass("active").siblings().removeClass("active");
  });
  
  // verticle tabs
  jQuery("ul._vlItems li").on("click", function(){
    jQuery(this).addClass("active").siblings().removeClass("active");
    const activeImg = jQuery(this).attr("data-img-id");
    console.log(activeImg);
    jQuery("#"+activeImg).show().siblings().hide();
  });

    if(jQuery( window ).width() < 992 ) {
      // horizontal tabs
      jQuery("._htTabControl").on("click", function(){
        jQuery("._htDesign ul._htHead").slideToggle();
      });

      jQuery("._updatesFilter h3").on("click", function(){
        jQuery("._upFilInner").slideToggle();
      });
      
      jQuery("._ptTabControl").on("click", function(){
        jQuery(".pillsTabs ul._ptList").slideToggle();
      });
      
      jQuery(".pillsTabs ul._ptList li").on("click", function(){
        var htTab = jQuery(this).text();
        jQuery("._ptTabControl span").text(htTab);
        jQuery(".pillsTabs ul._ptList").slideUp();
      });
      
      
      jQuery("._htDesign ul._htHead li").on("click", function(){
        var htTab = jQuery(this).text();
        jQuery("._htTabControl span").text(htTab);
        jQuery("._htDesign ul._htHead").slideUp();
      });
    }

  // accordion
    jQuery("._aHead").on("click", function(e) {
        e.preventDefault();
        if (jQuery(this).parent().hasClass("active")) {
            jQuery(this).parent().removeClass("active");
        } else {
            jQuery(this).parent().siblings().removeClass("active");
            jQuery(this).parent().addClass("active");
        }
    });

    // feature slider
    jQuery('._featureSlideShow').slick({
      infinite: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev slick-arrow"><svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.4 1 15 6.6l-5.6 5.6M15 6.6H1"></path></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow"><svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.4 1 15 6.6l-5.6 5.6M15 6.6H1"></path></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 596,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    // play chatbot video 
    $('._playBotVideo').on('click', function(){
        $(this).toggleClass('_playVideo');
        if ($(this).hasClass('_playVideo')) {
            $(this).next('video').trigger('play');
        }else {
            $(this).next('video').trigger('pause');        
        }
    });

    // copy offer code
    $('._copyOffer').on('click', function(){
      // console.time('time1');
      var temp = $("<input>");
      $("body").append(temp);      
      temp.val($(this).attr('data-offer')).select();
      document.execCommand("copy");
      temp.remove();
      // console.timeEnd('time1');
      var copyText = $(this).find('._ccBtnText').text();
      $(this).find('._ccBtnText').text('Code copied');
    });

    // multi layout slider
    $('._mlMain').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '._mlNav'
    });
    $('._mlNav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '._mlMain',
      dots: false,
      focusOnSelect: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg  style="transform: rotate(180deg);" height="14px" width="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"></path> </g></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg  height="14px" width="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"></path> </g></svg></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]      
    });

    // tooltip
    jQuery('._featureInfo').append("<span></span>");
    jQuery('._featureInfo:not([tooltip-position])').attr('tooltip-position','top');
    jQuery("._featureInfo").mouseenter(function(){
        jQuery(this).find('span').empty().append(jQuery(this).attr('data-tooltip'));
    });

    // show/hide plans
    jQuery("._ppControl button").on("click", function(){
      jQuery(this).toggleClass("active");
      jQuery("#_pricingPlans").slideToggle();
    });
  
  });